import { AxiosRequestConfig } from 'axios';

const MAX_POSSIBLE_TIME_MS = 2147483647; // for setTimeout

const sessionTTL = import.meta.env.VITE_APP_SESSION_TTL;
let maxAgeMs = MAX_POSSIBLE_TIME_MS;
if (sessionTTL && parseInt(sessionTTL, 10) < MAX_POSSIBLE_TIME_MS) {
  maxAgeMs = parseInt(sessionTTL, 10);
}

const notProduction = ['local', 'dev', 'qa'].includes(
  import.meta.env.VITE_APP_ENV as string,
);

const fastTrackMap: Record<string, string> = {
  dev: 'https://dev-apply.autopay.com',
  local: 'https://local-apply.autopay.com',
  prod: 'https://apply.autopay.com',
  qa: 'https://stage-apply.autopay.com',
  staging: 'https://stage-apply.autopay.com',
  test: 'https://dev-apply.autopay.com',
};

const lsPrefix = 'consumer_portal';

export const config = {
  version: import.meta.env.VITE_APP_VERSION,
  commitHash: import.meta.env.VITE_APP_COMMIT_HASH,
  defaultLeadChannelCode: 'CONSUMER_PORTAL',
  defaultLeadChannelCodeForCancelledApps: 'AUTOPAY_FAST_TRACK_API',
  api: {
    baseUrl:
      import.meta.env.VITE_APP_ENV === 'test'
        ? 'http://127.0.0.1:8041'
        : import.meta.env.VITE_APP_SERVICE_PUBLIC_URL,
    path: 'api',
  },
  fastTrackUrl: fastTrackMap[import.meta.env.VITE_APP_ENV || 'dev'],
  branding: {
    defaultId: 'AUTOPAY',
  },
  session: {
    maxAgeMs,
    CHECKLIGHT_TOKEN_KEY: `${lsPrefix}:token`,
  },
  debug: {
    workflow: notProduction,
    gates: notProduction,
    devtools: notProduction,
  },
  flowDataStorage: {
    encryptionEnabled:
      import.meta.env.VITE_APP_FLOW_DATA_STORAGE_ENCRYPTION === 'enabled',
    LOCAL_STORAGE_KEY: `${lsPrefix}:flow`,
  },
  unleash: {
    appName: 'consumer-portal-ui',
    clientKey: import.meta.env.VITE_APP_UNLEASH_CLIENT_KEY,
    url: import.meta.env.VITE_APP_UNLEASH_URL,
  },
  targetEnvironment: import.meta.env.VITE_APP_TARGET_ENVIRONMENT,
  fileUploadTimeout: 30000,
  loanDocuments: {
    dropzone: {
      accept: {
        'image/jpeg': ['.jpg', '.jpeg'],
        'image/png': ['.png'],
        'application/pdf': ['.pdf'],
      },
      maxFiles: 100,
      maxSize: 25e6, // 25MB
    },
    gap: {
      exampleDocumentUrl:
        'https://ap-consumer-portal.s3.amazonaws.com/product/protection-document-examples/gap-example/gap-example-0524.pdf',
    },
    ric: {
      exampleDocumentUrl:
        'https://ap-consumer-portal.s3.amazonaws.com/product/protection-document-examples/ric-example/ric-example-0524.pdf',
    },
    signedUrlConfig: {
      timeout: 5000,
    } as AxiosRequestConfig,
    uploadConfig: {
      timeout: 1000 * 60 * 5, // 5 minutes in milliseconds
    } as AxiosRequestConfig,
    vsc: {
      exampleDocumentUrl:
        'https://ap-consumer-portal.s3.amazonaws.com/product/protection-document-examples/vsc-example/vsc-example-0524.pdf',
    },
  },
};
